import React from "react";
import {restrictionService} from "../jwt/_services/clasificator/restrictionService";

export const restrictionProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await restrictionService.search(0, 1000, {});

        return listItems?.data?.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.name,
                    label: <label><b>{ item.name }</b> </label>
                }
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await restrictionService.getItem(id);
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}